import React, {useEffect, useState} from 'react';
import {getInvestment, investmentByCategory, fundInvestment, getInvestmentDetail} from "../../api/app";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import formatNumber from "../../utils/formatNumber";
import {capitalize} from "../../utils/capitalize";
import {truncate} from "../../utils/trunate";
import $ from "jquery";
import 'parsleyjs';
import {Link} from "react-router-dom";
import {toast} from "react-hot-toast";

const Investment = () => {
    const dispatch = useDispatch();
    const {investment} = useSelector((state) => state.app);
    const [selectedInvestment, setSelectedInvestment] = useState(null);
    const [investmentStats, setInvestmentStats] = useState({
        total: 0,
        totalAmount: 0
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getInvestment());
    }, []);

    const handleCategorySelection = (data) => {
        dispatch(investmentByCategory(data));
    }

    const showModal = (data) => {
        $("#staticBackdrop").modal("show");
        $(".modal-title").text(data.company.name);
        $("#modal-desc").text(data.description);
        $("#modal-amount").text(`K${formatNumber(data.amount)}`);
        $("#modal-type").text(data.type);
        $("#modal-equity").text(`${data.equity}%`);
        $("#modal-sector").text(data.sector);

        let link = data.document || "https://www.google.com";
        if (!/^https?:\/\//i.test(link)) {
            link = "https://" + link;
        }

        setSelectedInvestment(data);
        $("#doc-link").attr("href", link);
        $("#company-logo").attr("src", data.company.logo);
        getInvestmentDetail(data._id).then(response => {
            if(!response.error) {
                console.log(response.data);
                setInvestmentStats(response.data);
            }
        });
    }

    const showPaymentModal = () => {
        $("#staticBackdrop").modal("hide");
        $(".modal-backdrop").remove();
        $("#investment-form").parsley();

        $("#staticPaymentBackdrop").modal("show");
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = {
            id: selectedInvestment._id,
            mobile_number: $("#mobile_number").val(),
            amount: $("#amount").val()
        };

        setLoading(true);

        fundInvestment(data).then((response) => {
            setLoading(false);
            if(!response.error) {
                resetForm("staticPaymentBackdrop", "investment-form")
                toast.success("Investment successfully made. Thank you for the payment.", {position: 'top-center', duration: 5000});
            }
        });
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div id="investment-wrapper" style={{background: "#fff", borderRadius: 12, paddingBottom: 8, marginBottom: 21}}>
            <ul className="m-3 mb-5 list-unstyled text-center">
                <li className="list-inline-item"><Link to="#" onClick={handleCategorySelection.bind(null, "")}>All Category</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "agriculture")}>Agriculture</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "trading")}>Trading</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "service")}>Service</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "mining")}>Mining</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "energy")}>Energy</Link></li>
                <li className="list-inline-item ml-3 mr-3"><Link to="#" onClick={handleCategorySelection.bind(null, "tourism")}>Tourism</Link></li>
                <li className="list-inline-item"><Link to="#" onClick={handleCategorySelection.bind(null, "ict")}>ICT</Link></li>
            </ul>

            <div className="container">
                <div className="row">
                    {investment.length > 0 ? (
                        investment.map((item, index) => (
                            <div className="col-md-4" key={index}>
                                <div className="card-view" key={index} onClick={showModal.bind(this, item)}>
                                    <div className="company-detail">
                                        <div className="d-flex">
                                            {item?.company?.logo !== null ? <img src={item?.company?.logo} height="52" alt="company logo"/> : <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                                                                                                                                                   xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="25.5674" cy="25.5675" r="25.5395" fill="#85F9C3"/>
                                                <path
                                                    d="M23 35H29C34 35 36 33 36 28V22C36 17 34 15 29 15H23C18 15 16 17 16 22V28C16 33 18 35 23 35Z"
                                                    stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path
                                                    d="M28.3511 23.9101C28.2511 24.6201 27.8311 25.2201 27.2511 25.5801V27.5601C27.2511 28.2501 26.6911 28.8101 26.0011 28.8101C25.3111 28.8101 24.7511 28.2501 24.7511 27.5601V25.5801C24.1711 25.2201 23.7511 24.6201 23.6511 23.9101C23.6311 23.8001 23.6211 23.6801 23.6211 23.5601C23.6211 22.0401 25.0611 20.8601 26.6411 21.2801C27.4411 21.4901 28.0911 22.1401 28.3011 22.9401C28.3911 23.2701 28.4011 23.6001 28.3511 23.9101Z"
                                                    stroke="#0F0F0F" stroke-width="1.5" stroke-miterlimit="10"/>
                                                <path d="M36.0016 23.9102H28.3516" stroke="#0F0F0F" stroke-width="1.5"
                                                      stroke-miterlimit="10"/>
                                                <path d="M23.65 23.91H16" stroke="#0F0F0F" stroke-width="1.5" stroke-miterlimit="10"/>
                                            </svg>}
                                            <div className="ml-3">
                                                <h6>{item?.company?.name}</h6>
                                                <div className="d-flex">
                                                    <svg width="16" height="16" viewBox="0 0 13 13" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.64221 8.27128L8.1847 4.72879" stroke="#292D32" stroke-width="0.8125"
                                                              stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path
                                                            d="M4.86413 5.61695C5.23209 5.61695 5.53037 5.31867 5.53037 4.95071C5.53037 4.58275 5.23209 4.28445 4.86413 4.28445C4.49617 4.28445 4.19788 4.58275 4.19788 4.95071C4.19788 5.31867 4.49617 5.61695 4.86413 5.61695Z"
                                                            stroke="#292D32" stroke-width="0.8125" stroke-linecap="round"
                                                            stroke-linejoin="round"/>
                                                        <path
                                                            d="M8.4066 8.71525C8.77456 8.71525 9.07285 8.41695 9.07285 8.04899C9.07285 7.68103 8.77456 7.38275 8.4066 7.38275C8.03864 7.38275 7.74036 7.68103 7.74036 8.04899C7.74036 8.41695 8.03864 8.71525 8.4066 8.71525Z"
                                                            stroke="#292D32" stroke-width="0.8125" stroke-linecap="round"
                                                            stroke-linejoin="round"/>
                                                        <path
                                                            d="M6.50004 11.9167C9.49158 11.9167 11.9167 9.49155 11.9167 6.50001C11.9167 3.50847 9.49158 1.08334 6.50004 1.08334C3.5085 1.08334 1.08337 3.50847 1.08337 6.50001C1.08337 9.49155 3.5085 11.9167 6.50004 11.9167Z"
                                                            stroke="#292D32" stroke-width="0.8125" stroke-linecap="round"
                                                            stroke-linejoin="round"/>
                                                    </svg>
                                                    <p className="ml-1 label">{item?.equity}% {capitalize(item?.type)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="investment-detail mb-2">
                                        <p>{truncate(item?.description, 70)}</p>
                                        <h5>ZMW {formatNumber(item?.amount)}</h5>
                                        <div className="d-flex">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.33337 1.33331V3.33331" stroke="#7F7F7F" stroke-width="0.826389"
                                                      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M10.6666 1.33331V3.33331" stroke="#7F7F7F" stroke-width="0.826389"
                                                      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M2.33337 6.06H13.6667" stroke="#7F7F7F" stroke-width="0.826389"
                                                      stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path
                                                    d="M14 5.66665V11.3333C14 13.3333 13 14.6666 10.6667 14.6666H5.33333C3 14.6666 2 13.3333 2 11.3333V5.66665C2 3.66665 3 2.33331 5.33333 2.33331H10.6667C13 2.33331 14 3.66665 14 5.66665Z"
                                                    stroke="#7F7F7F" stroke-width="0.826389" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M7.99703 9.13326H8.00302" stroke="#7F7F7F" stroke-width="1.10185"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5.5295 9.13326H5.53549" stroke="#7F7F7F" stroke-width="1.10185"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5.5295 11.1333H5.53549" stroke="#7F7F7F" stroke-width="1.10185"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <span className="ml-1 tx-date">{moment(item?.createdAt).format("Do MMM, YYYY")}</span>
                                        </div>
                                        <div className="badge badge-warning mb-2 mt-2">
                                            <span>{item?.sector}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center py-5">
                            <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L6.35611 5.29545L10.409 9.3483L14.6516 13.5909L18.7046 17.6439L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L18.0737 19.1343C16.4783 20.1062 14.4611 20.75 12 20.75C8.28446 20.75 5.5928 19.2834 3.83476 17.4577C2.10654 15.663 1.25 13.485 1.25 12C1.25 10.3097 2.36419 7.67946 4.68861 5.74927L2.46967 3.53033C2.17678 3.23744 2.17678 2.76256 2.46967 2.46967ZM5.75447 6.81513C3.65136 8.50541 2.75 10.7939 2.75 12C2.75 13.015 3.39346 14.837 4.91524 16.4173C6.4072 17.9666 8.71554 19.25 12 19.25C14.0186 19.25 15.6642 18.7655 16.9768 18.0374L14.0679 15.1286C13.4752 15.521 12.7639 15.75 11.9999 15.75C9.92884 15.75 8.24991 14.0711 8.24991 12C8.24991 11.236 8.47892 10.5247 8.87133 9.93199L5.75447 6.81513ZM9.96907 11.0297C9.82845 11.3235 9.74991 11.6523 9.74991 12C9.74991 13.2426 10.7573 14.25 11.9999 14.25C12.3476 14.25 12.6764 14.1715 12.9702 14.0308L9.96907 11.0297ZM12 4.75C10.9651 4.75 10.0305 4.87735 9.19036 5.09792C9.03236 5.1394 8.87761 5.1842 8.72609 5.23211C8.33114 5.35697 7.90975 5.13803 7.78489 4.74309C7.66002 4.34814 7.87897 3.92675 8.27391 3.80189C8.44903 3.74652 8.62754 3.69485 8.80946 3.64709C9.77804 3.3928 10.8409 3.25 12 3.25C15.7155 3.25 18.4072 4.71662 20.1652 6.54227C21.8935 8.33695 22.75 10.515 22.75 12C22.75 13.0899 22.2895 14.5321 21.3966 15.9082C21.2795 16.0887 21.1545 16.2688 21.0215 16.4476C20.7743 16.78 20.3044 16.849 19.9721 16.6018C19.6397 16.3546 19.5707 15.8847 19.8179 15.5524C19.9317 15.3994 20.0385 15.2456 20.1383 15.0918C20.9206 13.886 21.25 12.7242 21.25 12C21.25 10.985 20.6065 9.16305 19.0848 7.58273C17.5928 6.03338 15.2845 4.75 12 4.75Z" fill="#22272F"/>
                            </svg>
                            <h5 className="empty-data">No data is available</h5>
                        </div>
                    )}
                </div>
            </div>

            <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="d-flex">
                                <img id="company-logo" className="mr-2" height="52" alt="company logo"/>
                                <div>
                                    <h5 className="modal-title" id="staticBackdropLabel">Investment Detail</h5>
                                    <span className="badge badge-warning" id="modal-sector">Agriculture</span>
                                </div>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20.5" cy="20.5" r="20" fill="white" stroke="black"/><path d="M26.4697 14.4697C26.7626 14.1768 27.2373 14.1768 27.5302 14.4697C27.8231 14.7626 27.8231 15.2373 27.5302 15.5302L22.0605 20.9999L27.5302 26.4697C27.8231 26.7626 27.8231 27.2373 27.5302 27.5302C27.2373 27.8231 26.7626 27.8231 26.4697 27.5302L20.9999 22.0605L15.5302 27.5302C15.2373 27.8231 14.7626 27.8231 14.4697 27.5302C14.1768 27.2373 14.1768 26.7626 14.4697 26.4697L19.9394 20.9999L14.4697 15.5302C14.1768 15.2373 14.1768 14.7626 14.4697 14.4697C14.7626 14.1768 15.2373 14.1768 15.5302 14.4697L20.9999 19.9394L26.4697 14.4697Z" fill="#22272F"/>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="modal-detail"><span id="modal-desc">No Data</span></p>
                            <p className="modal-value"><strong>Business Plan</strong><br/><a href="#" id="doc-link" target="_blank">View business plan</a></p>
                            <div className="d-flex justify-content-between">
                                <p className="modal-value"><strong>Investment Amount</strong><br/><span id="modal-amount">K200,000</span></p>
                                <p className="modal-value"><strong>Backed this investment</strong><br/><span className="text-capitalize">{investmentStats.total}</span></p>
                                <p className="modal-value"><strong>Amount Raised</strong><br/><span>K{investmentStats.totalAmount}</span></p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary btn-danger btn-block" onClick={showPaymentModal.bind(null)}>Support this project</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="staticPaymentBackdrop" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="d-flex">
                                <img id="company-logo" src={selectedInvestment?.company?.logo} className="mr-2" height="52" alt="company logo"/>
                                <div>
                                    <h5 className="modal-title" id="staticBackdropLabel">Investment Detail</h5>
                                    <span className="badge badge-warning" id="modal-sector">Agriculture</span>
                                </div>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20.5" cy="20.5" r="20" fill="white" stroke="black"/><path d="M26.4697 14.4697C26.7626 14.1768 27.2373 14.1768 27.5302 14.4697C27.8231 14.7626 27.8231 15.2373 27.5302 15.5302L22.0605 20.9999L27.5302 26.4697C27.8231 26.7626 27.8231 27.2373 27.5302 27.5302C27.2373 27.8231 26.7626 27.8231 26.4697 27.5302L20.9999 22.0605L15.5302 27.5302C15.2373 27.8231 14.7626 27.8231 14.4697 27.5302C14.1768 27.2373 14.1768 26.7626 14.4697 26.4697L19.9394 20.9999L14.4697 15.5302C14.1768 15.2373 14.1768 14.7626 14.4697 14.4697C14.7626 14.1768 15.2373 14.1768 15.5302 14.4697L20.9999 19.9394L26.4697 14.4697Z" fill="#22272F"/>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <form id="investment-form" className="parsley-style-1 mt-4" data-parsley-validate="true" onSubmit={handleSubmit.bind()}>
                            <div className="modal-body">
                                <div className="d-flex justify-content-between">
                                    <p className="modal-value"><strong>Investment Amount</strong><br/><span>K{selectedInvestment?.amount}</span></p>
                                    <p className="modal-value"><strong>Backed this investment</strong><br/><span className="text-capitalize">{investmentStats.total}</span></p>
                                    <p className="modal-value"><strong>Amount Raised</strong><br/><span>K{investmentStats.totalAmount}</span></p>
                                </div>
                                <div id="amountWrapper" className="form-group parsley-input">
                                    <label>Enter amount you want to invest?</label>
                                    <input id="amount" type="number" className="form-control"
                                           placeholder="Enter minimum amount of 10,000 and above"
                                           autoComplete="off"
                                           data-parsley-class-handler="#amountWrapper"
                                           required/>
                                </div>
                                <div id="mobileWrapper" className="form-group parsley-input">
                                    <label>Mobile Number</label>
                                    <input id="mobile_number" type="number" className="form-control"
                                           placeholder="Enter mobile money number"
                                           autoComplete="off"
                                           data-parsley-class-handler="#mobileWrapper"
                                           required/>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {loading ? <button className="btn btn-secondary btn-block" disabled><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/> Please Wait</button> : <button type="submit" className="btn btn-secondary btn-danger btn-block">Invest Now</button>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Investment;
